import { CurrentEnvironment } from 'root-constants'

type TGrowthbookConfig = {
  apiHost: string
  clientKey: string
}

const GROWTHBOOK_API_HOST = 'https://cdn.growthbook.io'

export const GROWTHBOOK_CONFIG_MAP: Record<
  CurrentEnvironment,
  TGrowthbookConfig
> = {
  [CurrentEnvironment.DEV]: {
    apiHost: GROWTHBOOK_API_HOST,
    clientKey: 'sdk-Jtv6zt89Gp7lTNFQ',
  },
  [CurrentEnvironment.DEV02]: {
    apiHost: GROWTHBOOK_API_HOST,
    clientKey: 'sdk-qTkpHYPhgyimZ1',
  },
  [CurrentEnvironment.STAGE]: {
    apiHost: GROWTHBOOK_API_HOST,
    clientKey: 'sdk-fRTfdh235WjXhMg',
  },
  [CurrentEnvironment.STAGE_QA]: {
    apiHost: GROWTHBOOK_API_HOST,
    clientKey: 'sdk-abSBC3I3SOVf8OLb',
  },
  [CurrentEnvironment.PROD]: {
    apiHost: GROWTHBOOK_API_HOST,
    clientKey: 'sdk-Z0b4BTzljYhsQf6A',
  },
}

export const getGrowthbookConfig = (): TGrowthbookConfig =>
  GROWTHBOOK_CONFIG_MAP[import.meta.env.CURRENT_ENV as CurrentEnvironment] ||
  GROWTHBOOK_CONFIG_MAP[CurrentEnvironment.DEV]
